module.exports = __webpack_public_path__ + "static/media/content_tea_shop_2.bda1aad8.png";